"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.5,3.83A1.79,1.79,0,0,0,5.71,5.61c0,.95,1.62,3.42,1.69,3.52a.11.11,0,0,0,.19,0C7.66,9,9.29,6.56,9.29,5.61A1.79,1.79,0,0,0,7.5,3.83Zm0,2.57a.78.78,0,1,1,.78-.78A.78.78,0,0,1,7.5,6.4Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.87,11.15A2.85,2.85,0,0,0,0,14c0,1.51,2.58,5.44,2.69,5.6a.18.18,0,0,0,.3,0c.11-.17,2.69-4.1,2.69-5.6A2.85,2.85,0,0,0,2.87,11.15Zm0,4.09A1.24,1.24,0,1,1,4.12,14,1.25,1.25,0,0,1,2.87,15.24Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.34,7.64A2.38,2.38,0,0,0,16,10c0,1.26,2.16,4.55,2.26,4.69a.15.15,0,0,0,.25,0c.09-.14,2.26-3.43,2.26-4.69A2.38,2.38,0,0,0,18.34,7.64Zm0,3.42a1,1,0,1,1,1-1A1,1,0,0,1,18.34,11.06Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.58,16.5a.5.5,0,0,1-.22-1l8.17-3.92a.5.5,0,1,1,.43.9L6.8,16.45A.5.5,0,0,1,6.58,16.5Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.25,10.58A.5.5,0,0,1,14,10.5L10,7.85A.5.5,0,0,1,10.55,7l4,2.65a.5.5,0,0,1-.28.92Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.87,20.43a.46.46,0,0,1-.28-.1l-1-.78-1,.77a.45.45,0,0,1-.71-.48l.35-1.25-.91-.77a.45.45,0,0,1,.29-.8h1.11l.45-1.13a.44.44,0,0,1,.42-.27h0a.45.45,0,0,1,.42.27L23.47,17h1.11a.45.45,0,0,1,.29.8L24,18.6l.35,1.26a.45.45,0,0,1-.44.57Zm-1.27-1.31,1.2.95a.12.12,0,0,0,.13,0A.11.11,0,0,0,24,20l-.41-1.47,1.08-.91a.11.11,0,0,0-.07-.2H23.24L22.7,16a.11.11,0,0,0-.1-.05h0a.11.11,0,0,0-.1.05L22,17.37H20.61a.11.11,0,0,0-.07.2l1.08.91-.41,1.46a.11.11,0,0,0,0,.12.11.11,0,0,0,.13,0Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,20.2a.28.28,0,0,0,.45-.3L12,18.54l1-.84a.28.28,0,0,0-.18-.5H11.63L11.14,16a.29.29,0,0,0-.53,0l-.49,1.24H8.89a.28.28,0,0,0-.18.5l1,.84-.38,1.35a.28.28,0,0,0,.45.3l1.1-.85Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19,17.39a.28.28,0,0,0-.27-.19H17.49L17,16a.29.29,0,0,0-.53,0L16,17.2H14.75a.28.28,0,0,0-.18.5l1,.84-.38,1.35a.28.28,0,0,0,.45.3l1.1-.85,1.1.86a.28.28,0,0,0,.45-.3l-.38-1.37,1-.84A.28.28,0,0,0,19,17.39Z",
    fill: "#004864"
  }));
};

exports["default"] = _default;